module.exports = __webpack_public_path__ + "img/dehsen.com-website__designs.3056ec63.jpg";